{
  "version": 1,
  "asset_id": "b28ed49c-34c7-4cd8-a121-a01229f8c42d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b28ed49c-34c7-4cd8-a121-a01229f8c42d/band-dilated-esophagus-annotated-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b28ed49c-34c7-4cd8-a121-a01229f8c42d/band-dilated-esophagus-annotated-800.webp",
  "original_filename": "band-dilated-esophagus-annotated-800.webp",
  "size": 16534,
  "content_type": "image/webp",
  "created_at": "2026-09-26T01:40:01Z"
}
